import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router';
import { opensAsPage, recordPage } from './open-in';
import { opensQuickViews } from './quick-view-pages';

// Which deal is open in the side sheet (TF-98): a deal opened from the board or the calendar, which stay
// the width of the window. In the address, ?deal=<id>, as a task's quick view is (useTaskQuickView), so
// a reload keeps it open and back closes it.

const PARAM = 'deal';

export function useDealQuickView() {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { tenantId = '' } = useParams();
  const edit = (change: (params: URLSearchParams) => void) => (current: URLSearchParams) => {
    const next = new URLSearchParams(current);
    change(next);
    return next;
  };
  return {
    // Only over the pages it belongs on (TF-385): on the files page ?deal= is the list's filter.
    dealId: opensQuickViews(location.pathname) ? params.get(PARAM) : null,
    // As a page instead, when the person chose that in My profile (TF-367).
    open: (id: string) =>
      opensAsPage('deal') && tenantId ? navigate(recordPage(tenantId, 'deal', id)) : setParams(edit((next) => next.set(PARAM, id)), { state: { dealQuickView: true } }),
    close: () => {
      if ((location.state as { dealQuickView?: boolean } | null)?.dealQuickView) navigate(-1);
      else setParams(edit((next) => next.delete(PARAM)), { replace: true });
    },
  };
}
